import { useCallback } from 'react';

import { useMarkMessageAsRead } from '@web/conversations/hooks/useMarkMessageAsRead';
import {
  useConversationActions,
  useConversationState,
} from '@web/conversations/Conversation/ConversationProvider/ConversationProvider';
import { getPrecedingMessage } from '@web/conversations/Conversation/ConversationProvider/conversationProvider.utils';
import { Message } from '@web/conversations/types/Message';

type Props = {
  conversationId: ID;
  message: Message;
};

export const useMarkMessageAsUnreadAction = () => {
  const { messages } = useConversationState();
  const { setUnreadMessagesCount, setUnreadMessageMarker } = useConversationActions();
  const mutation = useMarkMessageAsRead();

  const { mutateAsync } = mutation;

  const action = useCallback(
    async (payload: Props) => {
      try {
        const precedingMessage = getPrecedingMessage(messages, payload.message.id);

        setUnreadMessageMarker({
          customMarker: true,
          message: payload.message,
        });

        const { data } = await mutateAsync({
          conversationId: precedingMessage.conversationId,
          messageId: precedingMessage.id,
        });

        setUnreadMessagesCount({ count: data.unreadItems });
      } catch (e) {
        console.warn(e);
      }
    },
    [messages, mutateAsync, setUnreadMessageMarker, setUnreadMessagesCount]
  );

  return { action, mutation };
};
